import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { Observable } from 'rxjs';
import { CookieService } from "ngx-cookie-service";

/**
 * Pass untouched request through to the next request handler
 */

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private cookieService: CookieService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<any>> {
        let token = 'incontrol';

        if(this.cookieService.get('incontrol'))
        {
            token = this.cookieService.get('incontrol');
        }
        else if (localStorage.getItem('incontrol._access_token'))
        {
            token = localStorage.getItem('incontrol._access_token');
        }
        else if (localStorage.getItem('incontrol.annon_token'))
        {
            token = localStorage.getItem('incontrol.annon_token');
        }

        let authRequest = request.clone({
            headers: request.headers.set('Authorization', `${token}`)
        });
        authRequest = authRequest.clone({
            headers: authRequest.headers.set('Content-Type', 'application/json')
        })
        return next.handle(authRequest);
    }
} // Interceptor
